<script setup lang="ts">
import { ElIcon } from 'element-plus'

import { BoxComponent, FlexComponent, TypographyComponent } from '..'
import CheckIcon from '../../assets/icons/check.svg?component'

withDefaults(
  defineProps<{
    label: string
    selected?: boolean
    truncate?: boolean
    showSelectedIcon?: boolean
  }>(),
  {
    selected: false,
    truncate: false,
    showSelectedIcon: true,
  },
)
</script>

<template>
  <BoxComponent :p="16" w="100%" :title="truncate ? label : undefined">
    <FlexComponent flex="1" align="center" justify="space-between" :gap="12">
      <BoxComponent :max-w="truncate ? '90%' : undefined">
        <TypographyComponent :variant="selected ? 'title-large' : 'body-large'" :text-truncate="truncate">
          {{ label }}
        </TypographyComponent>
      </BoxComponent>
      <ElIcon v-if="showSelectedIcon && selected" :size="24">
        <CheckIcon />
      </ElIcon>
    </FlexComponent>
  </BoxComponent>
</template>
